var render = function render(){var _vm=this,_c=_vm._self._c;return _c('s-container',{staticClass:"footer-wrap bound-client-rect",attrs:{"fluid":_vm.fluid}},[_c('s-row',[_c('s-col',[_c('div',{ref:"footerContent",staticClass:"portal-footer-content",domProps:{"innerHTML":_vm._s(_vm.sanitizeFooterContent)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }